// extracted by mini-css-extract-plugin
export var hideEditor = "_s3-2";
export var infoIcon = "_s3-3";
export var label = "_s3-1";
export var labelContainer = "_s3-0";
export var readonlyText = "_s3-4";